import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../assets/styles/verifyotp.css";

function VerifyOTP() {
  const [emailOTP, setEmailOTP] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const email = localStorage.getItem("email") || "";

  const handleVerify = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const response = await fetch(
        "https://shuttle-craft-student-transport.onrender.com/api/students/verify-otp",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email, emailOTP }),
        }
      );

      const data = await response.json();

      if (!response.ok) {
        setError(data.message || "Verification failed");
        setLoading(false);
        return;
      }

      alert("✅ Verification Successful");

      localStorage.removeItem("email");
      navigate("/student-login");

    } catch (err) {
      setError("Server error");
    }

    setLoading(false);
  };

  const handleResend = async () => {
    try {
      await fetch(
        "https://shuttle-craft-student-transport.onrender.com/api/students/resend-otp",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email }),
        }
      );

      alert("📩 OTP sent again!");

    } catch (err) {
      setError("Server error");
    }
  };

  return (
    <div className="otp-container">
      <form className="otp-card" onSubmit={handleVerify}>
        <h2>Verify OTP</h2>

        {error && <p className="error">{error}</p>}

        <input
          type="text"
          placeholder="Enter Email OTP"
          value={emailOTP}
          onChange={(e) => setEmailOTP(e.target.value)}
          required
        />

        <button type="submit" disabled={loading}>
          {loading ? "Verifying..." : "Verify"}
        </button>

        <p style={{ marginTop: "12px" }}>Didn't get OTP?</p>

        <button type="button" onClick={handleResend}>
          🔁 Resend OTP
        </button>
      </form>
    </div>
  );
}

export default VerifyOTP;